/** @format */

import {
  GET_QUESTIONNAIRE_CARD,
  SET_QUESTIONNAIRE_CARD,
  GET_QUESTIONNAIRE_INTRO,
  SET_QUESTIONNAIRE_INTRO,
  GET_QUESTIONNAIRE_SECTION,
  SET_QUESTIONNAIRE_SECTION,
  GET_QUESTIONNAIRE_PAGE,
  SET_QUESTIONNAIRE_PAGE,
  SET_QUESTIONNAIRE_MENU,
  RESET_QUESTIONNAIRE,
  REFRESH_MENUS,
  SHOW_SPINNER,
  TOGGLE_USER_GUIDE,
  MOVE_AWAY_TRUE,
  USER_IS_ON_QUESTIONNAIRE,
  SET_FORM_VALUES,
  SET_HAS_ERROR,
  ELEMENTED_UPDATED,
  DISPLAY_POPUP
} from './questionnaireTypes';

const initialState = {
  gettingCardData: false,
  card: null,
  gettingIntroData: false,
  intro: null,
  gettingSectionData: false,
  section: null,
  gettingPageData: false,
  page: null,
  menu: [],
  menuIndex: 0,
  overallProgress: 0,
  sectionProgress: {},
  showModal: false,
  isCompleteModalDialogOpen: false,
  formValues: {},
  hasError: false,
  showSpinner: false,
  welcomeMessage: '',
  showUserGuide: false,
  elementUD:false,
  displayPU:false
};

const questionnaireReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUESTIONNAIRE_CARD: {
      return {
        ...state,
        card: null,
        gettingCardData: true,
      };
    }
    case SET_QUESTIONNAIRE_CARD: {
      return {
        ...state,
        card: action.payload,
        gettingCardData: false,
      };
    }
    case SET_QUESTIONNAIRE_MENU: {
      return {
        ...state,
        menu: action.payload.menu,
        sectionProgress: action.payload.sectionProgress,
        overallProgress: action.payload.progress,
        menuIndex: action.payload.index,
      };
    }
    case GET_QUESTIONNAIRE_INTRO: {
      return {
        ...state,
        intro: null,
        gettingIntroData: true,
      };
    }
    case SET_QUESTIONNAIRE_INTRO: {
      return {
        ...state,
        intro: {
          ...action.payload,
          menus: action.payload.menus ? [...action.payload.menus] : [],
        },
        gettingIntroData: false,
        welcomeMessage: action.payload.welcomeMessage,
      };
    }
    case GET_QUESTIONNAIRE_SECTION: {
      return {
        ...state,
        section: null,
        gettingSectionData: true,
      };
    }
    case SET_QUESTIONNAIRE_SECTION: {
      return {
        ...state,
        section: action.payload,
        gettingSectionData: false,
      };
    }
    case GET_QUESTIONNAIRE_PAGE: {
      return {
        ...state,
        page: null,
        gettingPageData: true,
      };
    }
    case SET_QUESTIONNAIRE_PAGE: {
      return {
        ...state,
        page: action.payload,
        gettingPageData: false,
      };
    }
    case REFRESH_MENUS: {
      return {
        ...state,
        page: { ...state.page, menus: action.payload },
        gettingPageData: false,
      };
    }
    case RESET_QUESTIONNAIRE:
      return initialState;
    case SHOW_SPINNER: {
      return {
        ...state,
        showSpinner: action.payload,
      };
    }
    case TOGGLE_USER_GUIDE: {
      return {
        ...state,
        showUserGuide: action.payload,
      };
    }
    case MOVE_AWAY_TRUE: {
      return {
        ...state,
        showModal: action.payload,
      };
    }
    case USER_IS_ON_QUESTIONNAIRE: {
      return {
        ...state,
        isUserOnQuestionnaire: action.payload,
      };
    }
    case SET_FORM_VALUES: {
      return {
        ...state,
        formValues: action.payload,
      };
    }
    case SET_HAS_ERROR: {
      return {
        ...state,
        hasError: action.payload,
      };
    }
    case ELEMENTED_UPDATED: {
      return {
        ...state,
        elementUD: action.payload,
      };
    }
    case DISPLAY_POPUP: {
      return {
        ...state,
        displayPU: action.payload,
      };
    }
    default:
      return state;
  }
};

export { initialState };
export default questionnaireReducer;



// WEBPACK FOOTER //
// ./src/ui/features/Questionnaire/state/questionnaireReducer.js